import { createLens } from '@dhmk/zustand-lens';
import type { StateCreator } from 'zustand';
import type { GraphState } from '.';
import type { NodeId, GraphId } from '../types/graph';
import type { IEvaluation, StoreSlice } from '@/store';

export interface EvaluationSlice {
  pendingNodeIds: NodeId[];

  addPendingNodes: (nodeIds: NodeId[]) => void;
  clearPendingNodes: (nodeIds?: NodeId[]) => void;
}

export const createEvaluationSlice =
  (
    global: StoreSlice,
    graphId: GraphId
  ): StateCreator<
    GraphState,
    [['zustand/immer', never]],
    [],
    EvaluationSlice & IEvaluation
  > =>
  (_set, _get) => {
    const [set, get] = createLens(_set, _get, ['eval']);

    return {
      ...global.graphs.evaluation(graphId),
      pendingNodeIds: [],

      addPendingNodes: (nodeIds) => {
        set((s) => {
          const unique = new Set(s.pendingNodeIds);
          nodeIds.forEach((nodeId) => unique.add(nodeId));
          s.pendingNodeIds = Array.from(unique);
        });
      },
      clearPendingNodes: (nodeIds) => {
        set((s) => {
          if (!nodeIds || nodeIds.length === 0) {
            s.pendingNodeIds = [];
            return;
          }
          const remove = new Set(nodeIds);
          s.pendingNodeIds = s.pendingNodeIds.filter(
            (nodeId) => !remove.has(nodeId)
          );
        });
      },
    };
  };
